/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, OnChanges, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, Inject, ViewChild } from '@angular/core';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { displayBundlePricingLevel } from 'app/modules/products/products.types';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl, ValidationErrors, ValidatorFn, FormArray, Form } from '@angular/forms';
import { PartsOrServicesFieldOptions, PartsOrServicesOptions } from '../update-parts-services/update-parts-services.interface';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MarkupEventAnalyticsService } from 'app/core/services/analytics/markup-event-analytics.service';
import _ from 'lodash';
import { LineItemPickerColumns, LineItemPickerColumnType, LineItemPickerOptions } from '../line-item-picker/line-item-picker.interface';
import { BundleLineItemModel } from '../product-bundle-item-picker/product-bundle-item-picker.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { bundlePricingLevel } from 'app/modules/products/products.types';
import { EditorOptions } from 'app/components/text-editor/text-editor.interface';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { UpdateBundleDescriptionComponent } from 'app/modules/jobs/job-details/edit-bundle-description/edit-bundle-description.component';
import { BadgeOptions } from '../badge/badge.interface';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { LineItemService } from 'app/core/services/lineitem/lineitem.service';
import { LineItemPickerComponent } from '../line-item-picker/line-item-picker.component';
import { UpdatePartsOrServicesComponent } from '../update-parts-services/update-parts-services.component';
import { LineItemPickerService } from '../line-item-picker/line-item-picker.service';
import { MatTable } from '@angular/material/table';
import { HotToastService } from '@ngneat/hot-toast';

@Component({
  selector: 'app-product-bundle-edit-form',
  templateUrl: './product-bundle-edit-form.component.html',
  styleUrls: ['./product-bundle-edit-form.component.scss'],
  changeDetection: ChangeDetectionStrategy?.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ProductBundleEditFormComponent implements OnInit, OnChanges, OnDestroy {

  @Input() options: any;
  @Input() selectedBundleDetails: any = null;
  @Input() masterProducts: any;
  @Input() isDisabled?: boolean = false;
  @Output() eventChange: EventEmitter<any> = new EventEmitter();
  partsFormFields: Array<PartsOrServicesFieldOptions>;
  @ViewChild(MatTable) table: MatTable<any>;

  updateProductBundleForm: FormGroup;
  displayBundlePricingLevel: any = displayBundlePricingLevel;
  companyCurrency: any;
  companyConfig: any;
  overallDiscountType: any;
  discountType: { key: any; value: string }[];
  showTaxPreference: boolean = false;
  showTaxCode: boolean = false;
  user: any;
  markupType: string = 'FLAT';
  markupValueSubscription: Subscription;
  discountValueSubscription: Subscription;
  currencyDecimal: number = this.utilityService.getCurrencyDecimal();
  purchasePrice: number;
  stepValue = this.utilityService.stepValue;
  lineItemsDisplayedColumns: Array<string> = [];
  displayedColumns: string[] = [];
  restrictedColumns = ['PRICE', 'PURCHASE_PRICE', 'MARKUP', 'DISCOUNT'];
  searchText: string = '';
  addOutOfStockProduct: boolean = true;
  addNegativeStockBalance: boolean = true;
  lineItemFormGroup: FormGroup;
  markupSubList: any = {};
  purchasePriceSubList: any = {};
  isPrimaryDetailsExpanded: boolean = true;
  isInvalidDragEvent: boolean = false;
  mockAssociatedProducts: any = [];
  getCategoryAsObject: boolean = false;
  updatingBundle: boolean = false;
  module: string = '';
  showEditor: boolean = false;
  currentUser: any;
  lineItemValueNotChanged: boolean = true;
  selectedRemoveItems: number[] = []; // indices or item references
  selectionMap: { [key: number]: boolean } = {};
  showLineItemAction: boolean = false;
  //Text Editor
  textEditorOptions: EditorOptions = {
    editorId:'bundle_description',
    attachmentType: 'JOB_NOTE',
    module:'PRODUCT_BUNDLE',
    isForm: true,
    showTemplate: false,
    showTable: false
  };

  //permissions
  isEditSellingPriceDisabled: boolean = false;
  showPrice: boolean = false;
  existingSerialNumbers: any = [];

  //location
  defaultPreferredLocationUid: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<ProductBundleEditFormComponent>,
    public utilityService: UtilityService,
    private changeDetectorRef: ChangeDetectorRef,
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private markupEventAnalyticsService: MarkupEventAnalyticsService,
    private zuperDialogService: ZuperDialogService,
    private dataCollectorService: DataCollectorService,
    private lineItemService: LineItemService,
    private lineItemPickerService: LineItemPickerService,
    private toast: HotToastService
  ) {
    this.companyCurrency = this.localStorageService.getLocalStorage('company')?.company_currency ?? 'USD';
    this.companyConfig = this.localStorageService.getLocalStorage('company_configuration_data');
    this.overallDiscountType = this.companyConfig.general?.discount?.discount_type ? this.companyConfig.general.discount.discount_type : 'FIXED';
    this.discountType = [{ key: this.companyCurrency, value: 'FIXED' }, { key: '%', value: 'PERCENTAGE' }];
    this.showPrice = this.utilityService.hasPermission('product.show_selling_price') ?? false;
    this.isEditSellingPriceDisabled = !this.utilityService.hasPermission('product.edit_selling_price');
    this.user = this.utilityService.user;
    this.lineItemFormGroup = this.formBuilder.group({
      tableRows: this.formBuilder.array([])
    });
  }

  ngOnInit(): void {
    this.options = this.data?.options ?? this.options;
    this.currentUser = this.localStorageService.getLocalStorage('user');
    this.selectedBundleDetails = this.data?.selectedBundleDetails ?? this.selectedBundleDetails;
    this.setBundleBaseQuanitity();
    this.selectedBundleDetails.associated_products = _.cloneDeep(this.selectedBundleDetails?.associated_products)?.map((data: any)=>({...data,location_availability : data?.location_availability ?? data?.product?.location_availability}));
    this.module = this.data?.module ?? this.module;
    if(this.options?.type === 'EDIT'){
      this.reCalulateBundleQuanitity();
      this.setModalOptions();
      this.setSelectedBundleProducts();
      this.updateProductBundleForm = this.formBuilder.group({});
      this.lineItemFormGroup = this.formBuilder.group({
        tableRows: this.formBuilder.array([])
      });
      this.buildFormFields();
      this.changeDetectorRef.detectChanges();
    }
    this.showEditor = false;
    this.activateEditor();
  }

  buildFormFields(): void {

    if(this.options?.columns?.length){
      this.updateDisplayedColumns();
    }

    let formFields = {};
    if (this.partsFormFields?.length && this.selectedBundleDetails && Object.keys(this.selectedBundleDetails).length > 0) {
      this.partsFormFields.forEach((element: any) => {
        let validators = [];
        if (element?.isRequired) {
          validators = [...validators, Validators.required];
        }
        if (element?.showField && (element?.displayType === 'input')) {
          if (['price', 'unit_price', 'purchase_price', 'selling_price'].includes(element?.fieldName)) {
            validators = [...validators, Validators.min];
          }

          if (element?.fieldName === 'quantity') {
            const quantity = this.selectedBundleDetails['quantity'];
            validators = [...validators, this.utilityService.numberMinValueValidator];

            formFields = {
              ...formFields, 'quantity': new FormControl({
                value: quantity || 1,
                disabled: (!this.utilityService.isEmptyOrUndefined(element?.isEditable) &&
                [true, false].includes(element?.isEditable) ? !element?.isEditable : false)
              },validators)
            };
            if(this.options?.type  === 'NEW') {
              this.selectedBundleDetails.quantity = 1;
            }
          }

          if (element?.fieldName === 'discount') {
            const discountType = (this.options?.type === 'EDIT') ? (this.selectedBundleDetails['discount_type'] && this.selectedBundleDetails['discount']) ? this.selectedBundleDetails['discount_type'] : this.overallDiscountType : this.overallDiscountType;
            const discount = (this.options?.type === 'EDIT') ? this.selectedBundleDetails['discount'] ?? '' : '';

            formFields = {
              ...formFields, 'discount_type': new FormControl({
                value: discountType,
                disabled: this.selectedBundleDetails?.pricing_level === bundlePricingLevel.ROLLUP || !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true, false].includes(element?.isEditable) ? !element?.isEditable : false
              },
                validators)
            };
            if (discountType === 'FIXED') {
              const quantity = this.selectedBundleDetails['quantity'];
              const price = this.selectedBundleDetails['price'] ?? this.selectedBundleDetails['unit_price'];
              const maxDiscountValue = this.getMaxValue(quantity, price);
              validators = [...validators, Validators.min(0), Validators.max(maxDiscountValue)];
            }else if(discountType === 'PERCENTAGE'){
              validators = [...validators, Validators.min(0), Validators.max(100)];
            }
            formFields = {
              ...formFields, 'discount': new FormControl({
                value: discount,
                disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true, false].includes(element?.isEditable) ? !element?.isEditable : false
              },
                validators)
            };
            this.selectedBundleDetails['discount_type'] = discountType;
          };
          if (element?.fieldName === 'tax_preference') {
            this.showTaxPreference = true;
            let taxPreferenceControlValue: boolean = false;
            if (this.selectedBundleDetails?.hasOwnProperty('tax')) {
              if (this.selectedBundleDetails.tax?.hasOwnProperty('tax_exempt')) {
                taxPreferenceControlValue = this.selectedBundleDetails.tax.tax_exempt;
              }
            }
            formFields = {
              ...formFields, 'tax_preference': new FormControl({
                value: taxPreferenceControlValue,
                disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true, false].includes(element?.isEditable) ? !element?.isEditable : false
              },
                validators)
            };
          }
          if (element?.fieldName === 'is_billable') {
            let is_billable: boolean = true;
            if (this.selectedBundleDetails?.hasOwnProperty('is_billable')) {
              is_billable = this.selectedBundleDetails?.is_billable;
            }
            formFields = {
              ...formFields, 'is_billable': new FormControl({
                value: is_billable,
                disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true, false].includes(element?.isEditable) ? !element?.isEditable : false
              },
                validators)
            };
          }
          if(element?.fieldName === 'tax_code') {
            this.showTaxCode = true;
            formFields = {
              ...formFields, 'tax_code': new FormControl({
                value: this.selectedBundleDetails?.tax?.tax_code,
                disabled: !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true, false].includes(element?.isEditable) ? !element?.isEditable : false
              },
                validators)
            };
          }
        }
        if (element?.fieldName === 'markup') {
          if ((this.companyConfig?.product?.enable_markup === true) && ((this.user?.role?.role_key === 'ADMIN') || this.showPrice) && (this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE)) {
            element.showField = true;
            let markupValue: number;
            if (this.selectedBundleDetails?.hasOwnProperty('markup')) {
              if(!this.utilityService.isEmptyOrUndefined(this.selectedBundleDetails.markup?.markup_value) && this.selectedBundleDetails.markup?.markup_type) {
                markupValue = this.selectedBundleDetails.markup.markup_value;
                this.markupType = this.selectedBundleDetails.markup.markup_type;
              }
            }
            formFields = {
              ...formFields, 'markup': new FormControl({
                value: this.selectedBundleDetails?.price >= 0 ? markupValue : null,
                disabled: (!this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true, false].includes(element?.isEditable) ? !element?.isEditable : false) || (this.options?.type === 'new')
              },
                validators
              )
            };
          }
        }
        if (element?.fieldName === 'purchase_price') {
          const isValidPurchasePrice = !this.utilityService.isEmptyOrUndefined(this.selectedBundleDetails?.purchase_price);
          const isValidProductPurchasePrice = this.utilityService.isEmptyOrUndefined(this.selectedBundleDetails?.product_ref_id?.purchase_price);
          const isValidUnitPrice = !this.utilityService.isEmptyOrUndefined(this.selectedBundleDetails?.unit_price_premarkup);
          const isValidProductUnitPrice = this.utilityService.isEmptyOrUndefined(this.selectedBundleDetails?.product_ref_id?.unit_price_premarkup);
          const isValidPrice = !this.utilityService.isEmptyOrUndefined(this.selectedBundleDetails?.price);
          const isValidProductPrice = this.utilityService.isEmptyOrUndefined(this.selectedBundleDetails?.product_ref_id?.price);

          if (isValidPurchasePrice || isValidProductPurchasePrice) {
            this.purchasePrice = this.selectedBundleDetails?.purchase_price ?? this.selectedBundleDetails?.product_ref_id?.purchase_price;
          } else if (isValidUnitPrice || isValidProductUnitPrice) {
            this.purchasePrice = this.selectedBundleDetails?.unit_price_premarkup ?? this.selectedBundleDetails?.product_ref_id?.unit_price_premarkup;
          } else if (isValidPrice || isValidProductPrice) {
            this.purchasePrice = this.selectedBundleDetails?.price ?? this.selectedBundleDetails?.product_ref_id?.price;
          }
          const isDisabled = !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false;
          const isRollupBundle = this.selectedBundleDetails?.pricing_level === bundlePricingLevel.ROLLUP;

          formFields = {
            ...formFields, 'purchase_price': new FormControl({
              value: this.purchasePrice,
              disabled: this.isEditSellingPriceDisabled || isRollupBundle || isDisabled
            },
              validators
            )
          };
        }
        if (element?.fieldName === 'price') {
          validators = ['text.unit_selling_price'].includes(element.fieldLabel) ? validators.filter(item => item.name !== 'min') : validators;
          const sellingPrice = this.selectedBundleDetails?.price ?? null;
          const isSellingPriceDisabled = this.selectedBundleDetails?.markup?.markup_value > 0;
          // const isDisabled = !this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true,false].includes(element?.isEditable) ? !element?.isEditable : false;
          formFields = {
            ...formFields, 'price': new FormControl({
              value: sellingPrice,
              disabled: this.isEditSellingPriceDisabled || (this.selectedBundleDetails?.pricing_level === bundlePricingLevel.ROLLUP) || isSellingPriceDisabled,
            },
              validators
            )
          };
        }
        if (element?.fieldName === 'product_description') {
          const productDescription = this.selectedBundleDetails?.product_description ?? null;
          formFields = {
            ...formFields, 'product_description': new FormControl({
              value: productDescription || '',
              disabled: (!this.utilityService.isEmptyOrUndefined(element?.isEditable) && [true, false].includes(element?.isEditable) ? !element?.isEditable : false)
            }, validators)
          };
        }
        if (['price', 'unit_price', 'purchase_price', 'selling_price', 'discount', 'markup'].includes(element?.fieldName) && !this.showPrice) {
          element.showField = false;
        }
      });

    }

    this.updateProductBundleForm = this.formBuilder.group(formFields);

    if (!this.selectedBundleDetails?.purchase_price && !this.selectedBundleDetails?.markup?.markup_value && this.options?.type === 'EDIT') {
      this.updateProductBundleForm.controls?.markup?.setValue('');
    }
    this.updateProductBundleForm.controls?.quantity?.valueChanges.pipe(debounceTime(100), distinctUntilChanged()).subscribe((response: any) => {
      if(this.lineItemValueNotChanged){
        this.selectedBundleDetails.quantity = response ?? this.selectedBundleDetails?.quantity;
        this.revalidateSerialNumbers();
        if(this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE){
          const discountType = this.selectedBundleDetails?.discount_type;
          const discountControl = this.updateProductBundleForm.controls['discount'];
          if(discountType === 'FIXED'){
            const quantity = this.selectedBundleDetails['quantity'];
            const price = this.selectedBundleDetails['price'] ?? this.selectedBundleDetails['unit_price'];
            const maxDiscountValue = this.getMaxValue(quantity, price);
            discountControl?.setValidators([Validators.min(0), Validators.max(maxDiscountValue)]);
          }else if(discountType === 'PERCENTAGE'){
            discountControl?.setValidators([Validators.min(0), Validators.max(100)]);
          }
          discountControl?.updateValueAndValidity();
        }
        if(this.selectedBundleDetails?.pricing_level === bundlePricingLevel.ROLLUP){
          this.selectedBundleDetails?.associated_products?.forEach((element: any, index: number) => {
            const lineItemDiscountControl = this.lineItemFormGroup.get(['tableRows', index, 'discount']);
            const lineItemQuantityControl = this.lineItemFormGroup.get(['tableRows', index, 'quantity']);
            const lineItemQuantity = this.selectedBundleDetails?.quantity * element?.base_quantity;
            lineItemQuantityControl.setValue(lineItemQuantity);
            const lineitemDiscountType = this.lineItemFormGroup.get(['tableRows', index, 'discount_type'])?.value;
            if(lineitemDiscountType === 'FIXED'){
              const price = this.lineItemFormGroup.get(['tableRows', index, 'price'])?.value;
              const bundleQuantity = this.selectedBundleDetails.quantity ?? 1;
              const quantity = bundleQuantity * element?.quantity;
              const maxDiscountValue = this.getMaxValue(quantity, price);
              lineItemDiscountControl.setValidators([Validators.min(0), Validators.max(maxDiscountValue)]);
            }else if(lineitemDiscountType === 'PERCENTAGE'){
              lineItemDiscountControl.setValidators([Validators.min(0), Validators.max(100)]);
            }
            lineItemDiscountControl?.updateValueAndValidity();
          });
        }
      }
    });

    if (this.updateProductBundleForm.controls?.purchase_price) {
      this.updateProductBundleForm.controls?.purchase_price?.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((response: any) => {

        if(this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE) {
          if (response >= 0) {
            this.updateProductBundleForm.controls?.markup?.enable({emitEvent: false});
            this.purchasePrice = this.updateProductBundleForm.controls?.purchase_price.value;
            const markupValue = this.updateProductBundleForm.controls?.markup?.value;
            if (!this.utilityService.isEmptyOrUndefined(markupValue) && markupValue >= 0) {
              this.updateSellingPrice(markupValue);
            }
          } else {
            this.updateProductBundleForm.controls?.markup?.setValue(null);
            this.markupType = 'FLAT';
            this.updateProductBundleForm.controls?.markup?.disable();
            const markupValue = this.updateProductBundleForm.controls?.markup?.value;
            this.updateSellingPrice(markupValue);
          }
        }
        else{
          this.updateProductBundleForm.controls?.markup?.disable();
          this.updateProductBundleForm.controls?.purchase_price?.disable();
        }
      });
    }

    if (this.updateProductBundleForm.controls?.markup) {
      this.markupValueSubscription = this.updateProductBundleForm.controls?.markup?.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((response: any) => {
        if (!this.utilityService.isEmptyOrUndefined(response) && response >= 0) {
          this.updateSellingPrice(response);
        } else {
          this.updateSellingPrice(null);
        }
      });
    }
    this.updateProductBundleForm.controls.price?.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((response: any) => {
      if(this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE) {
        if ((response >= 0 || response === null) && !this.utilityService.isEmptyOrUndefined(this.updateProductBundleForm.controls?.purchase_price?.value)) {
          this.updateProductBundleForm.controls?.markup?.enable({ emitEvent: false });
        }
      }
      else{
        this.updateProductBundleForm.controls?.markup?.disable();
      }

    });

    this.discountValueSubscription = this.updateProductBundleForm.controls?.discount?.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((response: any)=>{
      this.selectedBundleDetails.discount = response;
    });

    this.updateProducts();
  }

  getMaxValue(quantity, price): any {
    const maxValue = quantity * price;
    return maxValue;
  }

  getTotal(): any{
    const quantity = this.selectedBundleDetails['quantity'];
    const price = this.selectedBundleDetails['price'] ?? this.selectedBundleDetails['unit_price'];
    return this.getMaxValue(quantity, price);
  }

  markupValueChange(event): void {
    this.markupEventAnalyticsService.trackEventAnalytics(this.options?.module);
  }

  changeTaxCode(event: any): void {
    const taxcode = this.updateProductBundleForm.get('tax_code') as FormControl;
    taxcode.setValue(event);
  }

  changeMarkupType(type, element): void {
    this.markupEventAnalyticsService.trackEventAnalytics(this.options?.module);
    if(element){
      const selectedProduct: any = this.getSelectedProductWithModel(element);
      const rowIndex: number = this.selectedBundleDetails.associated_products.findIndex(productValue => element.product_uid === productValue.product.product_uid);
      if (selectedProduct && selectedProduct?.markup) {
        selectedProduct.markup['markup_type'] = type;
        if (!this.utilityService.isEmptyOrUndefined(selectedProduct.markup['markup_value'])) {
          this.updateLineItemSellingPrice(selectedProduct, rowIndex);
        }
      }
    }else{
      this.markupType = type;
      const bundleMarkup = this.updateProductBundleForm.controls['markup'].value;
      if(this.selectedBundleDetails?.markup?.markup_type && !this.utilityService.isEmptyOrUndefined(this.selectedBundleDetails?.markup?.markup_value)){
        this.selectedBundleDetails.markup_type = this.markupType;
      }else{
        this.selectedBundleDetails.markup = {
          markup_type: this.markupType,
          markup_value: bundleMarkup
        };
      }
      this.updateSellingPrice(bundleMarkup);
    }
  }

  updateSellingPrice(markupValue: number): void {
    if (markupValue >= 0 && markupValue !== null) {
      let updatedSellingPrice: number = 0;
      switch (this.markupType) {
        case 'FLAT':
          updatedSellingPrice = this.purchasePrice + markupValue;
          break;
        case 'PERCENTAGE':
          updatedSellingPrice = this.purchasePrice + (this.purchasePrice * (markupValue / 100));
          break;
        case 'MULTIPLIER':
          updatedSellingPrice = this.purchasePrice * markupValue;
          break;
        default:
          break;
      }
      if (updatedSellingPrice >= 0) {
        const fixedDecimalSellingPrice = updatedSellingPrice.toFixed(this.currencyDecimal);
        this.updateProductBundleForm.controls?.['price'].setValue(fixedDecimalSellingPrice);
        if (!this.utilityService.isEmptyOrUndefined(this.updateProductBundleForm?.controls?.markup?.value) && this.updateProductBundleForm?.controls?.markup?.value > 0) {
          this.updateProductBundleForm?.controls.price.disable();
        }
      }
    } else {
      if(this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE) {
        this.updateProductBundleForm.controls?.markup?.markAsTouched();
        if(!this.isEditSellingPriceDisabled){
          this.updateProductBundleForm?.controls?.price?.enable();
        }
        if (!this.utilityService.isEmptyOrUndefined(this.updateProductBundleForm.controls?.purchase_price?.value)) {
          this.updateProductBundleForm.controls?.['price'].setValue(this.purchasePrice);
        }
      }
    }
  }

  updateProducts(): void {
    this.createTableFormControls(this.selectedBundleDetails?.associated_products);
  }

  createTableFormControls(products: any): void {
    this.updateBasicRequiredProductValues(products);
    this.lineItemFormGroup.setControl('tableRows', this.formBuilder.array([]));
    const control: FormArray = this.lineItemFormGroup?.get('tableRows') as FormArray;
    const requiredColumns: any[] = this.options.columns?.filter(column => column?.isEditable);
    if (requiredColumns?.length) {
      products?.forEach((product: any, index: number) => {
        const formGroup: FormGroup = this.formBuilder.group({});
        formGroup.addControl('lineItem', new FormControl(product?.line_item_uid ?? product?.product_uid ?? product?.product_id));
        requiredColumns.forEach((columnInfo: LineItemPickerColumns) => {
          if (columnInfo.type === 'LOCATION') {
            let locationUid = '';
            const locationAvailability = product?.location_availability ?? product?.product?.location_availability;
            if(product?.location_uid){
              const locationObject = locationAvailability?.find(locationItem => locationItem?.location?.location_uid === product?.location_uid);
              locationUid = locationObject?.location?.location_uid;
            }else if(this.defaultPreferredLocationUid && locationAvailability?.some(locationItem => locationItem?.location?.location_uid === this.defaultPreferredLocationUid)){
              locationUid = this.defaultPreferredLocationUid;
            }else if(locationAvailability?.length > 1){
              const locationObject = locationAvailability.find(locationItem => locationItem?.quantity > 0);
              locationUid = locationObject?.location?.location_uid;
            }else if(locationAvailability?.length === 1){
              const locationObject = locationAvailability[0];
              locationUid = locationObject?.location?.location_uid;
            }
            product['location_uid'] = locationUid ?? null;
            const locationFormState: any = {
              value: locationUid ?? null,
              disabled: false
            };

            formGroup.addControl('location', new FormControl(locationFormState, columnInfo.isRequired ? Validators.required : null));
          }
          if (columnInfo.type === 'QUANTITY') {
            const quantityValue: number = product?.quantity;
            const quantityFormState = {
              value: quantityValue ?? null,
              disabled: false
            };
            let validators = [Validators.required, this.utilityService.numberMinValueValidator];
            formGroup.addControl('quantity', new FormControl(quantityFormState, validators));
          }
          if (columnInfo.type === 'PRICE') {
            const priceValue: number = product?.price ?? product?.unit_price;
            const isMarkup = this.isColumnAvailable(this.options.columns, LineItemPickerColumnType.MARKUP);
            const disablePrice = this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE || (isMarkup && product.markup?.['markup_value']);
            const priceFormState = {
              value: priceValue ?? null,
              disabled: this.isEditSellingPriceDisabled || disablePrice
            };
            formGroup.addControl('price', new FormControl(priceFormState, columnInfo.isRequired && this.showPrice ? Validators.required : null));
          }
          // if (columnInfo.type === 'DESCRIPTION') {
          //   const descriptionValue: number = product?.product_description ?? product?.description;
          //   const descriptionFormState: any = {
          //     value: descriptionValue ?? null,
          //     disabled: false
          //   };
          //   formGroup.addControl('description', new FormControl(descriptionFormState, columnInfo.isRequired ? Validators.required : null ));
          // }
          if (columnInfo.type === 'SERIAL_NO') {
            const serialNumberValue: number = product?.serial_nos ?? null;
            const serialNumberFormState: any = {
              value: serialNumberValue,
              disabled: false
            };
            formGroup.addControl('serialNumber', new FormControl(serialNumberFormState, columnInfo.isRequired ? Validators.required : null));
          }
          if (columnInfo.type === 'PURCHASE_PRICE' && this.selectedBundleDetails?.pricing_level !== bundlePricingLevel.BUNDLE) {
            const validators = [];
            const purchasePriceFormState = {
              value: null,
              disabled: this.isEditSellingPriceDisabled || this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE
            };
            if(!this.utilityService.isEmptyOrUndefined(product?.purchase_price)) {
              purchasePriceFormState.value = product?.purchase_price;
            }
            if (columnInfo?.isRequired) {
              validators.push(Validators.required);
            }
            validators.push(this.greaterThanZeroValidator(0, true));
            formGroup.addControl('purchase_price', new FormControl(purchasePriceFormState, validators));
          }
          if (columnInfo.type === 'MARKUP' && this.selectedBundleDetails?.pricing_level !== bundlePricingLevel.BUNDLE) {
            const markupValueFormState = {
              value: null,
              disabled: this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE
            };
            if(!this.utilityService.isEmptyOrUndefined(product?.markup?.markup_value)) {
              markupValueFormState.value = product?.markup.markup_value;
            }
            formGroup.addControl('markup_value', new FormControl(markupValueFormState, columnInfo.isRequired ? Validators.required : null));
          }
          if (columnInfo.type === 'DISCOUNT') {
            let validators = [];
            const discountType = (this.options?.type === 'EDIT') ? (product['discount_type'] && product['discount']) ? product['discount_type'] : this.overallDiscountType : this.overallDiscountType;
            const discount = (this.options?.type === 'EDIT') ? product['discount'] ?? '' : '';

            const discountTypeFormState = {
              value: discountType ?? null,
              disabled: !this.utilityService.isEmptyOrUndefined(columnInfo?.isEditable) && [true, false].includes(columnInfo?.isEditable) ? !columnInfo?.isEditable : false
            };

            formGroup.addControl('discount_type', new FormControl(discountTypeFormState, []));
            product['discount_type'] = discountType;

            if (discountType === 'FIXED') {
              const quantity = product['quantity'];
              const price = product['price'] ?? product['unit_price'];
              const maxDiscountValue = this.getMaxValue(quantity, price);
              validators = [...validators, Validators.min(0), Validators.max(maxDiscountValue)];
            }else if(discountType === 'PERCENTAGE'){
              validators = [...validators, Validators.min(0), Validators.max(100)];
            }

            const discountFormState = {
              value: discount ?? null,
              disabled: !this.utilityService.isEmptyOrUndefined(columnInfo?.isEditable) && [true, false].includes(columnInfo?.isEditable) ? !columnInfo?.isEditable : false
            };

            formGroup.addControl('discount', new FormControl(discountFormState, validators));
          }

          if(columnInfo.type === 'TAX_PREFERENCE') {
            const taxPreferenceValue: number = product?.tax?.tax_exempt ?? null;
            const taxPreferenceFormState: any = {
              value: taxPreferenceValue,
              disabled: false
            };
            formGroup.addControl('tax_preference', new FormControl(taxPreferenceFormState, columnInfo.isRequired ? Validators.required : null));
          }
          if(columnInfo.type === 'TAX_CODE' && this.selectedBundleDetails?.pricing_level !== bundlePricingLevel.BUNDLE) {
            const taxCode: number = product?.tax?.tax_code ?? null;
            const taxCodeFormState: any = {
              value: taxCode,
              disabled: false
            };
            formGroup.addControl('tax_code', new FormControl(taxCodeFormState, columnInfo.isRequired ? Validators.required : null));
          }
        });
        const serialNumber: AbstractControl = formGroup.get('serialNumber');
        if (serialNumber) {
          const serialNoColumn: LineItemPickerColumns = requiredColumns.find(column => column.type === LineItemPickerColumnType.SERIAL_NO);
          serialNumber.addValidators(this.validateSerialNumberCount(product, index, serialNoColumn?.multiple ?? false, serialNumber));
        }
        control.setControl(index, formGroup);
        this.handleInputSubscription(product, index);
      });
    }
    this.lineItemFormGroup?.get('tableRows')?.valueChanges?.pipe(debounceTime(500),distinctUntilChanged()).subscribe((data: any) => {
      this.updateSelectedProductValues(data);
    });
  }


  updateSelectedProductValues(data: any[]): void {
    data?.forEach((productValue: any, index: number) => {
      this.selectedBundleDetails?.associated_products.forEach((product: any) => {
        if (productValue.lineItem === (product?.line_item_uid ?? product?.product_uid ?? product.product_id)) {
          if (!this.utilityService.isEmptyOrUndefined(productValue?.purchase_price)) {
            const convertedPurchasePrice: number = Number(productValue.purchase_price);
            product['purchase_price'] = convertedPurchasePrice;
          }
          if (!this.utilityService.isEmptyOrUndefined(productValue?.markup) && productValue.markup?.markup_value) {
            const convertedMarkupValue: number = Number(productValue.markup.markup_value);
            product['markup_value'] = convertedMarkupValue;
          }
          if (!this.utilityService.isEmptyOrUndefined(productValue?.price)) {
            const convertedPrice: number = Number(productValue.price);
            product['price'] = convertedPrice;
            product['unit_price'] = convertedPrice;
          }
          if (!this.utilityService.isEmptyOrUndefined(productValue?.quantity)) {
            const convertedQuantity: number = Number(productValue.quantity);
            product['quantity'] = convertedQuantity;
          }
          if (productValue?.serialNumber) {
            product['serial_nos'] = typeof productValue.serialNumber === 'string' ? [productValue.serialNumber] : productValue.serialNumber?.map((value: any) => value?.label ? value.label : value);
          }

          if(!this.utilityService.isEmptyOrUndefined(productValue?.discount)){ // Discount value changes
            product['discount'] = productValue.discount ?? product['discount'];
          }

          if(!this.utilityService.isEmptyOrUndefined(productValue?.discount_type)){// Discount type value changes
            product['discount_type'] = productValue.discount_type ?? product['discount_type'];
          }

          if(!this.utilityService.isEmptyOrUndefined(productValue?.tax_preference)){
            product.tax = {
              ...product.tax,
              tax_exempt: productValue?.tax_preference ?? product?.tax?.tax_exempt
            };            
          }
          if (!this.utilityService.isEmptyOrUndefined(product?.quantity)) {
            this.setErrorsSerialNumberControl(product?.quantity, index);
          }
          if(productValue.hasOwnProperty('tax_code')){
            product['tax']['tax_code'] = productValue?.tax_code;
          }
          product['location_uid'] = !this.utilityService.isEmptyOrUndefined(productValue?.location) ? productValue.location : product['location_uid'];
          product['specification'] = !this.utilityService.isEmptyOrUndefined(productValue?.specification) ? productValue.specification : product['specification'];
          product['brand'] = !this.utilityService.isEmptyOrUndefined(productValue?.brand) ? productValue.brand : product['brand'];
          product['product_description'] = !this.utilityService.isEmptyOrUndefined(productValue?.description) ? productValue.description : product['description'];
        }
      });
    });

    if(this.selectedBundleDetails?.pricing_level === bundlePricingLevel.ROLLUP){
      this.calculateBundleFormTotalPrices();
    }
  }

  setErrorsSerialNumberControl(quantity: number, index: number): void {
    const serialNumber: AbstractControl = this.lineItemFormGroup?.get(['tableRows', index, 'serialNumber']);
    if (serialNumber) {
      const serialNumbers: any[] = serialNumber?.value;
      const bundleQuantity: number = this.updateProductBundleForm?.get('quantity')?.value || 1; // Default to 1 if undefined
      quantity *= bundleQuantity;
      if (quantity > 0 && serialNumbers?.length > 0 && serialNumbers?.length !== quantity) {
        serialNumber?.setErrors({ mismatchCount: true });
        serialNumber?.markAllAsTouched();
      } else {
        serialNumber?.setErrors(null);
      }
    }
  }

  serialNumberChanged(index: any,product): void{
    this.setErrorsSerialNumberControl(product?.quantity,index);
  }

  handleInputSubscription(product, index: number): void {
    const selectedProduct: any = this.getSelectedProductWithModel(product);
    if (selectedProduct) {
      if (this.utilityService.isEmptyOrUndefined(selectedProduct?.markup)) {
        selectedProduct['markup'] = {
          markup_type: 'FLAT'
        };
      }
    }
    const rowIndex: number = index;
    const subcriptionKey = product?.product_uid;
    if (selectedProduct) {
      const priceFormcontrol: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'price']);
      const markupFormControl: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'markup_value']);
      const purchasePriceFormControl: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'purchase_price']);
      const discountFormControl: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'discount']);
      if (markupFormControl) {
        const markupSubscription = markupFormControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((response) => {
          if (priceFormcontrol && this.selectedBundleDetails?.pricing_level === bundlePricingLevel.BUNDLE){
            priceFormcontrol.disable();
          }
          else {
            if (response >=0 && response !== null) {
              selectedProduct.markup['markup_value'] = response;
              if (!this.utilityService.isEmptyOrUndefined(selectedProduct?.markup['markup_value'])) {
                this.updateLineItemSellingPrice(selectedProduct, rowIndex);
                priceFormcontrol.disable();
              }
            } else {
              selectedProduct.markup['markup_value'] = null;
              if(!this.isEditSellingPriceDisabled){
                priceFormcontrol.enable();
              }
              this.updateLineItemSellingPrice(selectedProduct, rowIndex);
            }
          }
        });
        this.markupSubList[subcriptionKey] = markupSubscription;
      }
      if (purchasePriceFormControl) {
        if (this.utilityService.isEmptyOrUndefined(purchasePriceFormControl?.value) && priceFormcontrol?.value) {
          purchasePriceFormControl.setValue(priceFormcontrol.value);
          selectedProduct['purchase_price'] = priceFormcontrol.value;
          selectedProduct['unit_price_premarkup'] = priceFormcontrol.value;
        }
        const purchasePriceSubscription = purchasePriceFormControl.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((response) => {

          if(this.selectedBundleDetails?.pricing_level !== bundlePricingLevel.BUNDLE) {
            if (response >= 0) {
              selectedProduct['purchase_price'] = response;
              if(markupFormControl && markupFormControl.disabled){
                markupFormControl.enable({emitEvent:false});
              }
              if (!this.utilityService.isEmptyOrUndefined(selectedProduct.markup['markup_value'])) {
                this.updateLineItemSellingPrice(selectedProduct, rowIndex);
              }
            } else {
              selectedProduct.markup['markup_value'] = null;
              selectedProduct.markup['markup_type'] = 'FLAT';
              selectedProduct.purchase_price = null;
              if(markupFormControl){
                markupFormControl.setValue(null);
                markupFormControl.disable();
              }

            }
          }
          else{
            if(markupFormControl){
            markupFormControl.disable();
            }
          }

        });
        this.purchasePriceSubList[subcriptionKey] = purchasePriceSubscription;
      }
      if (priceFormcontrol) {
        priceFormcontrol.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe((response) => {
          selectedProduct['price'] = response;
          if(markupFormControl){
            if(this.selectedBundleDetails?.pricing_level !== bundlePricingLevel.BUNDLE) {
              if ((response > 0 || response === null) && !this.utilityService.isEmptyOrUndefined(selectedProduct?.purchase_price)) {
                markupFormControl?.enable({ emitEvent: false });
              }
            }
            else{
              markupFormControl?.disable({ emitEvent: false });
            }
          }
        });
      }
      if(discountFormControl){
        discountFormControl.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((response)=>{
          selectedProduct['discount'] = response;
        });
      }
    }
  }

  updateBasicRequiredProductValues(products: any[]): void {
    products?.forEach((product: any) => {
      product['available_quantity'] = !this.utilityService.isEmptyOrUndefined(product['available_quantity']) ? product['available_quantity'] : product?.quantity;
    });
  }

  isColumnAvailable(array, columnType): boolean {
    const matchedObject = array?.find(column => column.type === columnType);
    if (matchedObject) {
      return true;
    } else {
      return false;
    }
  }

  trackByValue(_index: number, item: any): any {
    return item.label ? item.label : item;
  }

  onSerialNoBlur(event: any,index,product): void {
    if (event?.target) {
      event.target.value = '';
    }
    this.setErrorsSerialNumberControl(product?.quantity,index);
  }

  validateSerialNumberCount(product: any, index: number, multiple: boolean, controller: AbstractControl): any {
    const quantityCol: any = this.options?.columns.find(column => column.type === LineItemPickerColumnType.QUANTITY);
    let quantity: any = quantityCol ? Number(product?.quantity) : 1;
    const bundleQuantity: number = this.updateProductBundleForm?.get('quantity')?.value || 1; // Default to 1 if undefined
    quantity *= bundleQuantity;
    const serialNumbers: string[] = multiple ? controller.value : (controller.value ? [controller.value] : []);
    if (quantity > 0 && serialNumbers?.length > 0 && serialNumbers?.length !== quantity) {
      return {
        mismatchCount: true
      };
    }
    return null;
  }

  getControlValue(index: number, controlName: string): any {
    const control = this.lineItemFormGroup?.get(['tableRows', index, controlName]);
    return control?.value ?? '';
  }

  onProductLocationChange(event: any, product: any, index: number): void {
    const locationUID: string = event?.value ?? '';
    const selectedProduct: any = this.getSelectedProductWithModel(product);
    if (selectedProduct) {
      selectedProduct['location_uid'] = locationUID;
      selectedProduct['serial_nos'] = null;
      const serialNumber = this.lineItemFormGroup.get(['tableRows', index, 'serialNumber']);
      serialNumber?.setValue(null);
      this.lineItemFormGroup.updateValueAndValidity();
    }
  }

  getLocationDetails(locationUid): void{
    const getLocationDetail = `${this.lineItemService?.lineItemAPIUrls?.productLocationUrl}/${locationUid}`
    this.dataCollectorService.getData(getLocationDetail).subscribe({
      next: (response)=>{
        if(response?.data){
          const locationDetails = response?.data;
          if(locationDetails?.is_deleted){
            return;
          };
        };
      }
    });
  };

  getSelectedProductWithModel(product: any): any {
    const matchedProduct = this.selectedBundleDetails?.associated_products?.find(value => value?.product_uid === product?.product_uid);
    return matchedProduct;
  }

  getMarkupType(element): string {
    const selectedProduct: any = this.getSelectedProductWithModel(element);
    return selectedProduct?.markup?.markup_type ?? this.markupType;
  }

  updateDisplayedColumns(): void {
    if (this.options?.columns?.length > 0) {
      if (this.selectedBundleDetails?.pricing_level === bundlePricingLevel.ROLLUP) {
        const columns = [
          { type: 'BULKACTION', isEditable: true },
          ...this.options.columns,
          { type: 'ACTION', isEditable: true }
        ];
        this.options.columns = columns;
      }
      const newColumns = this.options.columns.map(column => column.type);
      const allColumns = [...newColumns, ...this.displayedColumns];

      this.displayedColumns = allColumns.filter((value, index, self) => self.indexOf(value) === index);

      if (this.showPrice === false) {
        this.displayedColumns = this.displayedColumns.filter(value => !this.restrictedColumns.includes(value));
      } else if (this.showPrice && (this.companyConfig?.product?.enable_markup === false)) {
        this.displayedColumns = this.displayedColumns.filter(value => value !== 'MARKUP');
      }
      const columnToRemove = this.companyConfig?.taxation?.is_enabled ? 'TAX_PREFERENCE' : 'TAX_CODE';
      this.displayedColumns = this.displayedColumns.filter(value => value !== columnToRemove);
    }
  }

  getProductSerialNumbers(product: any): any {
    let serialNumbers: string[] = [];
    if (product) {
      const rowIndex: number = this.selectedBundleDetails?.associated_products?.findIndex(productValue => product?.product_uid === productValue?.product_uid);
      const selectedLocation = this.lineItemFormGroup.get(['tableRows', rowIndex, 'location'])?.value;
      const filteredLocation = this.options?.remoteData?.params['filter.location'];
      // if (product?.serial_nos?.length > 0 && this.options?.type === 'EDIT') {
      //   serialNumbers = product.serial_nos;
      // } else
      if (selectedLocation && product?.location_availability) {
        product?.location_availability?.forEach((location: any) => {
          if (location?.location?.location_uid === selectedLocation) {
            serialNumbers = serialNumbers.concat(location?.serial_nos ?? []);
          }
        });
      } else if (filteredLocation && product?.location_availability) {
        product.location_availability?.forEach((location: any) => {
          if (location?.location?.location_uid === filteredLocation) {
            serialNumbers = serialNumbers.concat(location?.serial_nos ?? []);
          }
        });
      }
    }
    return serialNumbers;
  }

  greaterThanZeroValidator(threshold: number, isSupportZero: boolean = false): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      const isValid = isSupportZero ? value >= threshold : value > threshold;
      if (value === null || value === undefined || value === '') {
        return null;
      }
      return isValid ? null : { 'min': true };
    };
  }

  updateLineItemSellingPrice(selectedProduct, rowIndex): void {
    const purchasePrice = selectedProduct?.purchase_price;
    const markupValue = selectedProduct?.markup?.markup_value;
    const markupType = selectedProduct?.markup?.markup_type;
    const priceFormcontrol = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'price']);
    const markupFormControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'markup_value']);
    if (markupValue > 0) {
      let updatedSellingPrice: number = 0;
      switch (markupType) {
        case 'FLAT':
          updatedSellingPrice = purchasePrice + markupValue;
          break;
        case 'PERCENTAGE':
          updatedSellingPrice = purchasePrice + (purchasePrice * (markupValue / 100));
          break;
        case 'MULTIPLIER':
          updatedSellingPrice = purchasePrice * markupValue;
          break;
        default:
          break;
      }
      if (updatedSellingPrice >= 0) {
        const fixedDecimalSellingPrice = updatedSellingPrice.toFixed(this.currencyDecimal);
        priceFormcontrol.setValue(fixedDecimalSellingPrice);
        selectedProduct['price'] = fixedDecimalSellingPrice;
      }
    } else if (markupValue === 0) {
      markupFormControl.markAsTouched();
      priceFormcontrol.setValue(purchasePrice);
      selectedProduct['price'] = purchasePrice;
    } else if (purchasePrice) {
      priceFormcontrol.setValue(purchasePrice);
      selectedProduct['price'] = purchasePrice;
    }
    priceFormcontrol.markAsUntouched();
    priceFormcontrol.updateValueAndValidity();
  }

  onModelChange(): void {
    if(this.mockAssociatedProducts?.length){
      const resultValue = this.mockAssociatedProducts.filter((data: any) => {
        const extendedData = { ...data, ...data.product };

        let isExist = false;
        Object.keys(extendedData).forEach((element: any) => {
          if (
            ['product_name', 'name','product_type', 'product_description'].includes(element) &&
            extendedData[element]?.toLowerCase()?.indexOf(this.searchText.toLowerCase()) >= 0
          ) {
            isExist = true;
          }
        });
        if (isExist) {
          return data;
        }
      });
      this.selectedBundleDetails.associated_products = resultValue;
      this.changeDetectorRef.markForCheck();
    }
 }

  calculateBundleFormTotalPrices(): void {
    let totalPurchasePrice = null;
    let totalSellingPrice = null;

    if(this.selectedBundleDetails.quantity) {
      this.selectedBundleDetails.associated_products.forEach((item) => {
        const purchasePrice = parseFloat(item.purchase_price ?? 0);
        const sellingPrice = parseFloat(item.price ?? item.unit_price ?? 0);

        totalPurchasePrice += purchasePrice * item.quantity;
        totalSellingPrice += sellingPrice * item.quantity;
      });

      // Apply company currency decimal precision
      const decimalPlaces = this.currencyDecimal ?? 2;
      totalPurchasePrice = parseFloat(totalPurchasePrice.toFixed(decimalPlaces));
      totalSellingPrice = parseFloat(totalSellingPrice.toFixed(decimalPlaces));
      
      this.updateProductBundleForm.controls?.['purchase_price'].setValue(totalPurchasePrice);
      this.updateProductBundleForm.controls?.['price'].setValue(totalSellingPrice);
    }

  }

  createLineItemModel(product: any): BundleLineItemModel {
    const unitPrice: number = !this.utilityService.isEmptyOrUndefined(product['price'] ?? product['unit_price']) ? (product['price'] ?? product['unit_price']) : 0;
    const quantity: number = !this.utilityService.isEmptyOrUndefined(product['quantity']) ? product['quantity'] : 0;
    const itemModel: BundleLineItemModel = {
      ...product,
      'product_category': this.getCategoryAsObject ? (product?.product_category ?? '') : (product?.product_category?.category_uid ?? ''),
      'product_description': product['product_description'] ?? '',
      'product_name': product['name'] ?? product['product_name'],
      'product_image': product['product_image'] ?? null,
      'product_id': product['product_id'],
      'product_type': product['product_type'] ?? null,
      'product_uid': product['product_uid'],
      'quantity': quantity,
      'price': unitPrice,
      'meta': product?.meta_data ?? [],
      'location_uid': (product['product_type'] && product['product_type'] !== 'SERVICE') ? (product?.location_uid ?? '') : '',
      'purchase_price': product['purchase_price'],
      'is_billable': product['is_billable']
    };

    itemModel['name'] = product['name'] ?? product['product_name'];
    itemModel['unit_price'] = unitPrice;
    if (product['description']) {
      itemModel['description'] = product['description'];
    }
    if (product['specification']) {
      itemModel['specification'] = product['specification'];
    }
    if (product['brand']) {
      itemModel['brand'] = product['brand'];
    }
    if (product['prefix']) {
      itemModel['prefix'] = product['prefix'];
    }
    if (product['pricing_level']) {
      itemModel['pricing_level'] = product['pricing_level'];
    }
    if (product['uom']) {
      itemModel['uom'] = product['uom'];
    }
    if (product?.['tax']){
      itemModel['tax'] = product?.tax;
    }
    if (product?.['serial_nos']){
      itemModel['serial_nos'] = product?.serial_nos;
    }
    if(product?.group_uid || product?.product_group_uid){
      itemModel['group_uid'] = product?.group_uid ||  product?.product_group_uid;
    }

    if(product?.group_name || product?.product_group_name){
      itemModel['group_name'] = product?.group_name || product?.product_group_name;
    }

    if(product?.location_uid && product?.location_availability?.length){
      const locationArray = product.location_availability.filter(locationDetails =>  locationDetails?.location?.location_uid === product?.location_uid);
      itemModel['location_name'] = locationArray.length ? locationArray[0].location?.location_name : '';
    }
    if(product['markup'] && product['markup'].markup_value){
      itemModel['markup'] = product.markup;
    }
    if(product['unit_price_premarkup']){
      itemModel['unit_price_premarkup'] = product.unit_price_premarkup;
    }else if(product['markup'] && product['markup'].markup_value && (product['purchase_price'] || product['unit_price'])){
      itemModel['unit_price_premarkup'] = product['purchase_price'] ?? product['unit_price'];
    }
    if(product['available_quantity']){
      itemModel['available_quantity'] = product.available_quantity;
    }
    if(product['line_item_uid']){
      itemModel['line_item_uid'] = product.line_item_uid;
    }
    if(product['associated_products']){
      itemModel['associated_products'] = product.associated_products;
    }
    return itemModel;
  }

  createAssociatedLineItemModel(products: any): any {
    const PayloadAssociatedProducts: any = [];
    const bundleQuantity: number = this.selectedBundleDetails.quantity;
    products?.forEach((product: any) => {
      const unitPrice: number = !this.utilityService.isEmptyOrUndefined(product['price'] ?? product['unit_price']) ? (product['price'] ?? product['unit_price']) : 0;
      const quantity: number = !this.utilityService.isEmptyOrUndefined(product['quantity']) ? product['quantity'] : 0;
      const itemModel: any = {
        'product_description': product['product_description'] ?? '',
        'product_name': product['product']?.['name'] ?? product['product']?.['product_name'] ?? product['name'] ?? '',
        'product_image': product['product']?.['product_image'] ?? product['product_image'] ?? '',
        'product_id': product['product_id'],
        'product_type': product['product_type'] ?? null,
        'product_uid': product['product_uid'],
        'quantity': quantity /bundleQuantity,
        'price': unitPrice,
        'location_uid': product?.location_uid ?? '',
        'purchase_price': product['purchase_price'],
        'product': product['product'],
        'is_billable': product['is_billable']
      };

      itemModel['name'] = product['product']?.['name'] ?? product?.['product']?.['product_name'] ?? product['name'] ?? '';
      itemModel['unit_price'] = unitPrice;
      if (product['product_description']) {
        itemModel['description'] = product['product_description'];
      }
      if (product['specification']) {
        itemModel['specification'] = product['specification'];
      }
      if (product['brand']) {
        itemModel['brand'] = product['brand'];
      }
      if (product['prefix']) {
        itemModel['prefix'] = product['prefix'];
      }
      if (product['uom']) {
        itemModel['uom'] = product['uom'];
      }
      if (product?.['tax']){
        itemModel['tax'] = product?.tax;
      }
      if (product?.['serial_nos']){
        itemModel['serial_nos'] = product?.serial_nos;
      }

      if(product?.location_availability?.length){
        product['location_availability'] = product.location_availability;
      }

      if(product?.location_uid && product?.location_availability?.length){
        const locationArray = product.location_availability.filter(locationDetails =>  locationDetails?.location?.location_uid === product?.location_uid);
        itemModel['location_name'] = locationArray.length ? locationArray[0].location?.location_name : '';
      }
      if(product['markup'] && product['markup'].markup_value){
        itemModel['markup'] = product.markup;
      }
      if(product['unit_price_premarkup']){
        itemModel['unit_price_premarkup'] = product.unit_price_premarkup;
      }else if(product['markup'] && product['markup'].markup_value && (product['purchase_price'] || product['unit_price'])){
        itemModel['unit_price_premarkup'] = product['purchase_price'] ?? product['unit_price'];
      }
      if(product['available_quantity']){
        itemModel['available_quantity'] = product.available_quantity;
      }
      if(product?.discount_type) {
        itemModel['discount'] = product?.discount ?? 0;
        itemModel['discount_type'] = product?.discount_type;
      }
      if(product['line_item_uid']){
        itemModel['line_item_uid'] = product.line_item_uid;
      }
      if (product.markup?.value) {
        const markupPayload = {
          markup_type: product?.markup?.type,
          markup_value: product?.markup?.value,
        };
        product['markup'] = markupPayload;
      } else {
        delete product['markup'];
      }

      PayloadAssociatedProducts.push(itemModel);

    });

    return PayloadAssociatedProducts;
  }

  validateSelectedItemsControls(): boolean {
    this.updateProductBundleForm.markAsUntouched();
    this.lineItemFormGroup.markAsUntouched();
    this.updateProductBundleForm.markAllAsTouched();
    let isValid: boolean = true;
    this.selectedBundleDetails.associated_products.forEach((product: any) => {
      const rowIndex: number = this.selectedBundleDetails.associated_products.findIndex(productValue => product.product_uid === productValue.product_uid);
      if (rowIndex > -1) {
        const itemRowControl: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex]);
        itemRowControl?.markAllAsTouched();
        if (itemRowControl?.valid === false) {
          isValid = false;
        }
      }
    });

    if (!this.updateProductBundleForm?.invalid && isValid) {
      if(this.options?.type === 'EDIT'){
        this.constructBundleItemPayload();
      }
      else{
        return true;
      }
    }
    return false;
  }

  constructBundleItemPayload(): any{
    const payloadProductBundleData = this.createLineItemModel(this.selectedBundleDetails);
    const { price, purchase_price, product_description } = this.updateProductBundleForm.value;

    payloadProductBundleData['price'] = price ?? null;
    payloadProductBundleData['purchase_price'] = purchase_price ?? null;
    payloadProductBundleData['product_description'] = product_description ?? null;

    const unitPrice = this.updateProductBundleForm.controls?.price?.value;
    const purchasePrice = this.updateProductBundleForm.controls?.purchase_price?.value;
    const productDescription = this.updateProductBundleForm.controls?.product_description?.value;

    if(!this.updateProductBundleForm.value['price']){
      payloadProductBundleData['price'] = unitPrice;
    }

    if(!this.updateProductBundleForm.value['purchase_price']){
      payloadProductBundleData['purchase_price'] = purchasePrice;
    }

    if(!this.updateProductBundleForm.value['product_description']){
      payloadProductBundleData['product_description'] = productDescription;
    }


    if (this.showTaxPreference) {
      const taxPayload = {
        tax_exempt: '',
      };
      const productLevelTax = this.selectedBundleDetails?.tax;
      const productMasterTax = this.selectedBundleDetails?.product_ref_id?.tax;
      if(productLevelTax){
        taxPayload.tax_exempt = productLevelTax?.tax_exempt;
        if(productLevelTax?.tax_rate && productLevelTax?.tax_name) {
            taxPayload['tax_name'] = this.selectedBundleDetails.tax.tax_name;
            taxPayload['tax_rate'] = this.selectedBundleDetails.tax.tax_rate;
        }
      }else if(productMasterTax?.tax_name && productMasterTax?.tax_rate){
        taxPayload['tax_name'] = productMasterTax.tax_name;
        taxPayload['tax_rate'] = productMasterTax.tax_rate;
      }
      payloadProductBundleData['tax'] = taxPayload;
    }

    if(this.showTaxCode){
      const taxPayload = {
        tax_code: this.updateProductBundleForm.value['tax_code'],
      };
      payloadProductBundleData['tax'] = taxPayload;
    }

    if (this.updateProductBundleForm.controls?.markup?.value) {
      const markupPayload = {
        markup_type: this.markupType,
        markup_value: this.updateProductBundleForm.controls?.markup?.value,
      };
      payloadProductBundleData['markup'] = markupPayload;
      payloadProductBundleData['unit_price_premarkup'] = this.purchasePrice;
    } else {
      delete payloadProductBundleData['markup'];
    }
    delete payloadProductBundleData['tax_preference'];

    if (this.selectedBundleDetails?.discount_type) {
      payloadProductBundleData['discount'] = this.selectedBundleDetails?.discount ?? 0;
      payloadProductBundleData['discount_type'] = this.selectedBundleDetails?.discount_type;
    }

    if(this.selectedBundleDetails.associated_products?.length){
      const associatedProductsData = this.createAssociatedLineItemModel(this.selectedBundleDetails.associated_products);
      payloadProductBundleData['associated_products'] = associatedProductsData;
    }

    payloadProductBundleData['is_billable'] = this.updateProductBundleForm.controls?.is_billable?.value

    if(this.options?.type === 'EDIT'){
      this.dialogRef.close(payloadProductBundleData);
    }
    else{
      return payloadProductBundleData;
    }
  }

  setSelectedBundleProducts(): void{
    if(this.selectedBundleDetails?.associated_products?.length){
      this.mockAssociatedProducts = _.cloneDeep(this.selectedBundleDetails?.associated_products);
    }
  }

  setModalOptions(): void{
    const pricingLevel = this.selectedBundleDetails?.pricing_level;

    if(pricingLevel && this.options?.type === 'EDIT'){
      if (pricingLevel === bundlePricingLevel.ROLLUP && this.options.fieldOptions) {
        this.options.fieldOptions = this.options.fieldOptions.filter(value => value?.fieldName !== 'markup');
      } else if (pricingLevel === bundlePricingLevel.BUNDLE && this.options.columns) {
        this.options.columns = this.options.columns.filter(value => !['PURCHASE_PRICE', 'MARKUP'].includes(value?.type));
      }
    }

    // Remove Tax preference and discount columns for bundle level pricing
    if(pricingLevel === bundlePricingLevel.BUNDLE){
      this.options.columns = this.options.columns.filter(value => !['TAX_PREFERENCE', 'DISCOUNT'].includes(value?.type));
    }

    // Remove TAX column or tax_preference field based on pricing level and taxable status
    if (!this.options.isTaxable) {
      if (pricingLevel === bundlePricingLevel.ROLLUP) {
        this.options.columns = this.options.columns.filter(value => value?.type !== 'TAX_PREFERENCE');
      } else if (pricingLevel === bundlePricingLevel.BUNDLE) {
        this.options.fieldOptions = this.options.fieldOptions.filter(value => value?.fieldName !== 'tax_preference');
      }
    }

    // Remove markup column or discount field based on pricing level and transaction type
    if (this.options.currentTransactionType !== 'LINE_ITEM') {
      if (pricingLevel === bundlePricingLevel.ROLLUP) {
        this.options.columns = this.options.columns.filter(value => value?.type !== 'DISCOUNT');
      } else if (pricingLevel === bundlePricingLevel.BUNDLE) {
        this.options.fieldOptions = this.options.fieldOptions.filter(value => value?.fieldName !== 'discount');
      }
    }

    const restrictedFieldOptions = ['purchase_price', 'markup', 'price'];
    const isRollup = pricingLevel === bundlePricingLevel.ROLLUP;
    const isBundle = pricingLevel === bundlePricingLevel.BUNDLE;

    if(!this.showPrice){
      if(isRollup){
        this.options.columns = this.options.columns.filter(value => !this.restrictedColumns.includes(value?.type));
      }else if(isBundle){
        this.options.fieldOptions = this.options.fieldOptions.filter(value => !restrictedFieldOptions.includes(value?.fieldName));
      };
    }else if(this.showPrice && this.companyConfig?.product?.enable_markup === false){
      if(isRollup){
        this.options.columns = this.options.columns.filter(value => value?.type !== 'MARKUP');
      }else if(isBundle){
        this.options.fieldOptions = this.options.fieldOptions.filter(value => value?.fieldName !== 'markup');
      };
    };

    this.partsFormFields = this.options?.fieldOptions;
    if(this.options?.getCategoryAsObject){
      this.getCategoryAsObject = this.options?.getCategoryAsObject ?? false;
    }
  }

  onDiscountTypeChange(event): void{
    const discountType = event?.value;
    const discountControl = this.updateProductBundleForm.controls['discount'];
    this.overallDiscountType = discountType;
    this.selectedBundleDetails.discount_type = discountType;
    if(discountType === 'FIXED'){
      const quantity = this.selectedBundleDetails['quantity'];
      const price = this.selectedBundleDetails['price'] ?? this.selectedBundleDetails['unit_price'];
      const maxDiscountValue = this.getMaxValue(quantity, price);
      discountControl.setValidators([Validators.min(0), Validators.max(maxDiscountValue)]);
    }else if(discountType === 'PERCENTAGE'){
      discountControl.setValidators([Validators.min(0), Validators.max(100)]);
    }
    discountControl.updateValueAndValidity();
  }

  onTaxPreferenceChange(event): void{
    this.selectedBundleDetails.tax.tax_exempt = event?.value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    let shouldUpdateFormFields = false;
    if ('options' in changes) {
      this.options = changes.options.currentValue ?? [];
      if (this.options) {
        this.setModalOptions();
        const defaultLocationUid = this.currentUser?.meta_data?.default_product_location;
        const isLocationEnabled = this.isColumnAvailable(this.options?.columns, LineItemPickerColumnType.LOCATION);
        if(defaultLocationUid && isLocationEnabled && !this.defaultPreferredLocationUid){
          this.defaultPreferredLocationUid = defaultLocationUid;
          this.getLocationDetails(defaultLocationUid);
        };
      }
    }

    if ('selectedBundleDetails' in changes) {

      const prevSelectedBundleDetails = changes.selectedBundleDetails.previousValue;
      const newSelectedBundleDetails = changes.selectedBundleDetails.currentValue ?? {};

      this.selectedBundleDetails = newSelectedBundleDetails;
      this.setBundleBaseQuanitity();
      if (!_.isEqual(prevSelectedBundleDetails, newSelectedBundleDetails)) {
        shouldUpdateFormFields = true;
      }

      this.selectedBundleDetails = newSelectedBundleDetails ?? {};
      this.markupType = this.selectedBundleDetails?.markup?.markup_type ?? this.companyConfig?.product?.default_markup_type ?? 'FLAT';
      this.setSelectedBundleProducts();
      this.showEditor = false;
      this.activateEditor();
    }

    if ('masterProducts' in changes) {
      this.masterProducts = changes.masterProducts.currentValue ?? {};
    }

    this.changeDetectorRef.markForCheck();

    if (shouldUpdateFormFields && this.options && this.selectedBundleDetails) {
        this.updateProductBundleForm = this.formBuilder.group({});
        this.lineItemFormGroup = this.formBuilder.group({
          tableRows: this.formBuilder.array([])
        });
        this.displayedColumns = [];
        this.buildFormFields();
        this.changeDetectorRef.detectChanges();
    }
  }

  onProductDiscountTypeChange(event, rowIndex, product): void{
    const discountType = event?.value;
    const lineitemDiscountControl = this.lineItemFormGroup.get(['tableRows', rowIndex, 'discount']);
    if(discountType === 'FIXED'){
      const price = this.lineItemFormGroup.get(['tableRows', rowIndex, 'price']).value;
      const quantity = product?.quantity;
      const maxDiscountValue = this.getMaxValue(quantity, price);
      lineitemDiscountControl.setValidators([Validators.min(0), Validators.max(maxDiscountValue)]);
    }else if(discountType === 'PERCENTAGE'){
      lineitemDiscountControl.setValidators([Validators.min(0), Validators.max(100)]);
    }
    lineitemDiscountControl.updateValueAndValidity();
  }

  changeLineItemTaxCode(event: any, rowIndex: number): void {
    const taxcode =  this.lineItemFormGroup?.get(['tableRows', rowIndex, 'tax_code']) as FormControl;
    taxcode.setValue(event);
  }

  revalidateSerialNumbers(): void {
    const tableRows = this.lineItemFormGroup.get('tableRows') as FormArray;
    tableRows.controls.forEach((formGroup: FormGroup, index: number) => {
      const product = this.selectedBundleDetails?.associated_products[index];
      this.setErrorsSerialNumberControl(product?.quantity, index);
    });
  }

  activateEditor(): void {
      this.showEditor = true;
  }

  initEditor(event): void { }

  editDescription(element, index): void{
    const jobDescriptionDialog = this.zuperDialogService.openCustom(UpdateBundleDescriptionComponent,{
      data: element.product_description ?? element.description,
      extraClass:'update-schedule-date'
     });
     jobDescriptionDialog.afterClosed().subscribe((result: any)=>{
      if (result !== undefined && result !== null) {
        if(this.selectedBundleDetails.associated_products?.length) {
            const description: AbstractControl = this.lineItemFormGroup?.get(['tableRows', index, 'description']);
            this.selectedBundleDetails.associated_products[index].product_description = result;
            if (description) {
              description.setValue(result);
            }
            this.changeDetectorRef.detectChanges();
          }
        }
      });
  }

  getBadgeOptions(status): BadgeOptions{
    const badgeOption: BadgeOptions = {
      type: '',
      displayType: 'chip',
      displayKey: 'text.non.billable',
      displayName: 'Non-Billable',
      backgroundColor: '#F3E4EC',
      color: '#AC5684',
      extraClass: ''
    };
    return badgeOption;
  }

  disableParentScroll(): void {
    const parent = document.querySelector('.bundle-item-picker-container');
    if (parent) {
      parent.classList.add('no-scroll');
    }
  }
  
  enableParentScroll(): void {
    const parent = document.querySelector('.bundle-item-picker-container');
    if (parent) {
      parent.classList.remove('no-scroll');
    }
  }

  addLineItems(_event: any, addItemType: string): void {
    if (addItemType === 'add_item') {
      this.openLineItemPicker(_event);
    } else if (addItemType === 'add_custom_item') {
      this.addCustomLineItem(_event);
    }
  }

  openLineItemPicker(event: Event, parts?: any, module?: string): void {
    let remoteData = null;
    if(this.utilityService.isEmptyOrUndefined(parts)){
      remoteData = {
        dataUrl: this.lineItemService.lineItemAPIUrls.productUrl,
      };
    }
    const lineItemPickerData = this.options?.lineItemPickerOptions;
    const lineItemDialog: any = this.zuperDialogService.openCustom(LineItemPickerComponent,
      {
        extraClass: 'line-item-picker-container',
        data: lineItemPickerData
      });
    lineItemDialog.disableClose = true;
    const onAddItemClicked: any = this.lineItemPickerService.onAddItemClicked.subscribe((response: any) => {
      lineItemDialog.close(response);
    });
    lineItemDialog.afterClosed().subscribe((lineItems: any) => {
      onAddItemClicked.unsubscribe();
      if(lineItems){
        lineItems.forEach((lineItem: any) => {
          const newLineItem = {
            ...lineItem,
            quantity: lineItem.quantity || 1,
            purchase_price: lineItem.purchase_price || 0,
            price: lineItem.price || 0,
            markup: lineItem.markup || { markup_type: 'FLAT', markup_value: 0 },
            tax: lineItem.tax || {},
            location_uid: lineItem.location_uid || null,
            serial_nos: lineItem.serial_nos || [],
          };

          this.selectedBundleDetails.associated_products.push(newLineItem);
        });
        this.onLineItemQuantityChange();
        this.createTableFormControls(this.selectedBundleDetails.associated_products);
        this.lineItemFormGroup.updateValueAndValidity();
        this.table?.renderRows();
        this.changeDetectorRef.detectChanges();
        if(this.selectedBundleDetails?.pricing_level === bundlePricingLevel.ROLLUP){
          this.calculateBundleFormTotalPrices();
        }
      }
    });
  }

  
  getLineItemsProductColumns(): LineItemPickerColumns[] {
      return [{
        type: LineItemPickerColumnType.LINE_ITEM,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.CATEGORY,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.TYPE,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.BRAND,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.SPECIFICATION,
        isEditable: false
      },
      {
        type: LineItemPickerColumnType.LOCATION,
        isEditable: true
      },
      {
        type: LineItemPickerColumnType.SERIAL_NO,
        isEditable: true,
        isRequired: false,
        multiple: true
      },
      {
        type: LineItemPickerColumnType.PURCHASE_PRICE,
        isEditable: true,
      },
      {
        type: LineItemPickerColumnType.MARKUP,
        isEditable: true,
      },
      {
        type: LineItemPickerColumnType.PRICE,
        isEditable: true,
        isRequired: true
      },
      {
        type: LineItemPickerColumnType.QUANTITY,
        isEditable: true,
        isRequired: true
      }];
  }

  addCustomLineItem(event: Event): void {
      const editPartsDialog = this.zuperDialogService.openCustom(UpdatePartsOrServicesComponent,{
        module: this.module,
        options: this.options?.customLineItemPickerOptions,
        extraClass:'update-job-part'
      });
  
      editPartsDialog.afterClosed().subscribe((lineItem: any)=>{
        if (lineItem) {
          lineItem['line_item_type'] = 'ITEM';
          delete lineItem.update_all_jobs;
        
          const normalizedLineItems = Array.isArray(lineItem)
            ? lineItem
            : [lineItem];
        
          normalizedLineItems.forEach((lineItemEntry: any) => {
            const newLineItem = {
              ...lineItemEntry,
              quantity: lineItemEntry.quantity || 1,
              purchase_price: lineItemEntry.purchase_price || 0,
              price: lineItemEntry.price || 0,
              markup: lineItemEntry.markup || { markup_type: 'FLAT', markup_value: 0 },
              tax: lineItemEntry.tax || {},
              location_uid: lineItemEntry.location_uid || null,
              serial_nos: lineItemEntry.serial_nos || [],
            };
        
            this.selectedBundleDetails.associated_products.push(newLineItem);
            this.table?.renderRows();
          });
          this.onLineItemQuantityChange();
          this.createTableFormControls(this.selectedBundleDetails.associated_products);
          this.lineItemFormGroup.updateValueAndValidity();
          this.changeDetectorRef.detectChanges();
        
          if (this.selectedBundleDetails?.pricing_level === bundlePricingLevel.ROLLUP) {
            this.calculateBundleFormTotalPrices();
          }
        }
      });
  }

  onLineItemQuantityChange(): void{
    this.lineItemValueNotChanged = false;
    this.selectedBundleDetails.quantity = 1;
    this.updateProductBundleForm.controls?.quantity.setValue(1);
    this.updateProductBundleForm.controls?.quantity.disable();
  }

  onCheckboxChange(index: number): void {
    if (this.selectionMap[index]) {
      this.selectedRemoveItems.push(index);
    } else {
      this.selectedRemoveItems = this.selectedRemoveItems.filter(i => i !== index);
    }
    this.showLineItemAction = !!this.selectedRemoveItems?.length;
    this.toggleActionColumn(!this.showLineItemAction);
  }

  toggleActionColumn(show: boolean): void {
    const hasAction = this.displayedColumns.includes('ACTION');
  
    if (show && !hasAction) {
      this.displayedColumns = [...this.displayedColumns, 'ACTION'];
    } else if (!show && hasAction) {
      this.displayedColumns = this.displayedColumns.filter(col => col !== 'ACTION');
    }
  }

  removeSelectedLineItems(): void {
    const totalItems = this.selectedBundleDetails?.associated_products?.length;
    const selectedCount = this.selectedRemoveItems?.length;
  
    if (selectedCount === 0) {
      return;
    }
  
    if (selectedCount >= totalItems) {
      this.toast.error(this.utilityService.getLocaleValue('alert.remove.atleast_one_product_required'));
      return;
    }
  
    // Remove items safely by filtering
    this.selectedBundleDetails.associated_products = this.selectedBundleDetails.associated_products
      .filter((_, index) => !this.selectedRemoveItems.includes(index));
  
    this.selectedRemoveItems = []; // Reset selection
    this.showLineItemAction = false;
    this.toggleActionColumn(true);
    this.selectionMap = {}; // Reset selection map
    this.onLineItemQuantityChange();
    this.createTableFormControls(this.selectedBundleDetails.associated_products);
    this.lineItemFormGroup.updateValueAndValidity();
    this.table?.renderRows();
    this.calculateBundleFormTotalPrices();
  }

  removeLineItem(index: number): void {
    if (this.selectedBundleDetails.associated_products.length <= 1) {
      this.toast.error('At least one product is required in the bundle');
      return;
    }

    // Remove the item at the specified index
    this.selectedBundleDetails.associated_products = this.selectedBundleDetails.associated_products.filter((_, i) => i !== index);
    // Update the form controls and table
    this.onLineItemQuantityChange();
    this.createTableFormControls(this.selectedBundleDetails.associated_products);
    this.lineItemFormGroup.updateValueAndValidity();
    this.table?.renderRows();
    this.calculateBundleFormTotalPrices();
  }

  setBundleBaseQuanitity(): void {
    if (this.selectedBundleDetails?.associated_products?.length) {
      const isAlreadyUpdated = this.selectedBundleDetails.associated_products.every(
        (product: any) => product.hasOwnProperty('base_quantity')
      );

      if (!isAlreadyUpdated) {
        this.selectedBundleDetails.associated_products = this.selectedBundleDetails.associated_products.map((product: any) => ({
          ...product,
          base_quantity: product.quantity
        }));
      }
    }
  }

  reCalulateBundleQuanitity(): void { 
    if (this.selectedBundleDetails?.associated_products?.length) {
      if (Array.isArray(this.selectedBundleDetails.associated_products) && this.selectedBundleDetails.quantity != null) {
        this.selectedBundleDetails.associated_products.forEach((product: any) => {
          if (product.base_quantity != null) {
            product.quantity = this.selectedBundleDetails.quantity * product.quantity;
          }
        });
      }
    }
  }

  ngOnDestroy(): void {
    if (this.markupValueSubscription) {
      this.markupValueSubscription.unsubscribe();
    }
    if(this.discountValueSubscription){
      this.discountValueSubscription.unsubscribe();
    }
  }

}
